import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/final-result/bg.png'
import downloadBtnImage from '../assets/images/final-result/download.png';
import moreBtnImage from '../assets/images/final-result/more.png';
import domtoimage from 'dom-to-image-improved';
import { saveAs } from 'file-saver';
import constant from '../assets/const.json';
import Cookies from 'universal-cookie';
import fetchTimeout from 'fetch-timeout';

const APP_NAME_PREFIX = "Shipping-Game_";
const cookies = new Cookies();

class FinalResult extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
        this.state = {
            score1: this.props.location.state.game1Score,
            score2: this.props.location.state.game2Score,
        };
    }

    componentDidMount() {
        let uid = cookies.get('uid');
        let score1 = this.state.score1;
        let score2 = this.state.score2;
        console.log('[Params] get uid from cookie = ' + uid);
        if (uid === null || uid === undefined) {
            uid = '';
            console.log('[Params] generate random uuid : ' + uid);
        }
        console.log('[Params] shipping score1 = ' + score1 + ', score2 = ' + score2);
        this.postDataToServer(uid, score1, score2);
    }

    getRequestBody(uid, score1, score2) {
        return {
            uid: uid,
            shipping_score1: score1,
            shipping_score2: score2,
            action: 'result'
        };
    }

    postDataToServer(uid, score1, score2) {
        let apiPath = constant.WEB_API_PATH;
		fetchTimeout(apiPath, {
            headers: {
                'Content-Type': 'application/json'
            },
			method: 'POST',
			body: JSON.stringify(this.getRequestBody(uid, score1, score2))
        }, 5 * 1000, '[WebAPI] Timeout')
        .then(response => response.json())
		.then(data => {
			if (data.success) {
                // call api ok
                console.log('[WebAPI] success');
            } else {
                // call api failed
                console.log('[WebAPI] failed');
            }
		}).catch(e => {
			console.log('[WebAPI] ' + e);
		});
    }
    
    goToMorePage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './more'
        });
    };

    downloadResultImage() {
        let element = document.getElementById('result-div');
        let scale = constant.DESIRED_RATIO_WIDTH / element.clientWidth;
        domtoimage.toBlob(element, {
            width: constant.DESIRED_RATIO_WIDTH,
            height: constant.DESIRED_RATIO_HEIGHT,
            style: {
                transform: 'scale(' + scale + ')',
                transformOrigin: 'top left'
            }
        })
        .then(function (blob) {
            const date = new Date();
            const mm = date.getMonth() + 1;
            const dd = date.getDate()
            const month = (mm > 9 ? '' : '0') + mm
            const day = (dd > 9 ? '' : '0') + dd
            const year = date.getFullYear();
            saveAs(blob, APP_NAME_PREFIX + year + month + day + '.png');
        });
    }

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <div id='result-div' style={{ position: 'absolute', width: '100%', height: '100%', left: '0px', top: '0px' }}>
                    <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                    <div style={{ position: 'absolute', right: '24.5%', top: '32.5%', width: '10%', height: '10%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#152b85">{this.props.location.state.game1Score}</text>
                        </svg>
                    </div>
                    <div style={{ position: 'absolute', right: '24.5%', top: '43.5%', width: '10%', height: '10%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#152b85">{this.props.location.state.game2Score}</text>
                        </svg>
                    </div>
                    <div style={{ position: 'absolute', right: '43%', top: '62.5%', width: '10%', height: '10%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#ea551b">{this.props.location.state.game1Score + this.props.location.state.game2Score}</text>
                        </svg>
                    </div>
                </div>
                <img className='press-btn' alt='' src={downloadBtnImage} style={{ height: '12%', bottom: '4%', left: '28.5%', position: 'absolute', background: 'transparent' }} onClick={this.downloadResultImage.bind(this)}/>
                <img className='press-btn' alt='' src={moreBtnImage} style={{ height: '12%', bottom: '4%', left: '54.5%', position: 'absolute', background: 'transparent' }} onClick={this.goToMorePage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(FinalResult);
